function positionFilters() {
  const filters = document.querySelector(".collection__filters");
  const mobileTargetContainer = document.querySelector(".collection__mobile-filters-target-container");
  const desktopTargetContainer = document.querySelector(".collection__desktop-filter-target-container");

  let isMobileView = true;

  if (window.innerWidth >= 960) {
    desktopTargetContainer.appendChild(filters);
    isMobileView = false;
  }

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 960 && isMobileView) {
      desktopTargetContainer.appendChild(filters);
      isMobileView = false;
    } else if (window.innerWidth < 960 && !isMobileView) {
      mobileTargetContainer.appendChild(filters);
      isMobileView = true;
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  positionFilters();
});
